"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useValidation;

var _react = require("react");

var _Context = _interopRequireDefault(require("@sift/runner/Context"));

var _getValidation = _interopRequireDefault(require("@sift/runner/getValidation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyValidationResult = {
  errorMessages: [],
  errors: [],
  isValid: true
};

function useValidation(value, _node, _config) {
  var contextValue = (0, _react.useContext)(_Context.default);
  var nodeFromContext = contextValue && contextValue.node;
  var configFromContext = contextValue && contextValue.config;
  var node = _node || nodeFromContext;
  var config = _config || configFromContext;

  if (!config) {
    throw new Error('[useValidation] expected `config` either from context or params');
  }

  return (0, _react.useMemo)(function () {
    if (!node) {
      return emptyValidationResult;
    }

    return (0, _getValidation.default)(value, node, config);
  }, [value, node, config]);
}